import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { IsLoggedIn } from "@grandvisionhq/auth";
import { useIntl } from "@grandvisionhq/state";
import { useStoreFinderContext, Hooks, Components } from "@grandvisionhq/stores-v2";
import { aabPreferredStoreClickEvent } from "../../../../../../../data-layer/v3/data-layer/actions.js";
import PreferredStoreTile from "../../../../../../PreferredStoreTile/v3/components/PreferredStoreTile/PreferredStoreTile.js";
const { HighlightPreferredStore } = Components;
const { useGetPreferredStore } = Hooks;
const getStoreAppointmentType = (store, appointmentTypeId) => {
  return store?.appointmentTypes?.find(
    (appointmentType) => appointmentType.id === appointmentTypeId && appointmentType.isAvailableInStore
  );
};
const HighlightPreferredStoreContainer = ({ applicableAppointmentTypeId }) => {
  const { getLabel } = useIntl();
  const { setPreferredStore } = useStoreFinderContext();
  const { data: store } = useGetPreferredStore();
  const title = getLabel("stores.component.storeFinder.preferredStoreTile.title");
  const showPreferredStore = applicableAppointmentTypeId ? !!getStoreAppointmentType(store, applicableAppointmentTypeId) : true;
  React.useEffect(() => {
    if (store && showPreferredStore) {
      setPreferredStore(store);
    }
  }, [store, setPreferredStore, showPreferredStore]);
  const handleOnClickPreferredStoreTile = (store2) => {
    DataLayer.pushEvent(
      aabPreferredStoreClickEvent({
        store: store2
      })
    );
  };
  if (!store || !showPreferredStore) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(HighlightPreferredStore, { title }, /* @__PURE__ */ React.createElement(PreferredStoreTile, { store, onClick: handleOnClickPreferredStoreTile }));
};
const HighlightPreferredStore$1 = (props) => /* @__PURE__ */ React.createElement(IsLoggedIn, null, /* @__PURE__ */ React.createElement(HighlightPreferredStoreContainer, { ...props }));
export {
  HighlightPreferredStore$1 as default
};
//# sourceMappingURL=HighlightPreferredStoreContainer.js.map
